const FeatureType = {
    ANALYTICS: "analytics",
    CUSTOM_FONTS: "customFonts",
    FOLDERS: "folders",
    DESKTOP_APP: "desktopApp",
    SECURED_SHARING: "securedSharing",
    DISABLE_LINKS: "disableLinks",
    REVISION_HISTORY: "revisionHistory",
    CREATE_PRESENTATIONS: "createPresentations",
    CREATE_SLIDES: "createSlides",
    PLAYER_SETTINGS: "playerSettings",
    TEAMS: "teams",
    SSO: "sso",
    REMOVE_BAI_BRANDING: "removeBaiBranding",
    VIDEO_UPLOAD: "videoUpload",
    NOTIFICATIONS: "notifications",
    COMMENTS: "comments",
    REMOTE_MEETINGS: "remoteMeetings",
    VIEW_LIBRARY_ITEMS: "viewLibraryItems",
    EDIT_LIBRARY_ITEMS: "editLibraryItems",
    MANAGE_TEAM: "manageTeam",
    MANAGE_ORG: "manageOrg",
    MANAGE_TEAM_BILLING: "manageTeamBilling",
    API: "api",
    AUTO_PLAY_EMBEDDED: "autoPlayEmbedded",
    UPGRADE: "upgrade",
};

const F = FeatureType;

const freeFeatures = {
    [F.CREATE_SLIDES]: 100,
};

const proFeatures = {
    [F.ANALYTICS]: true,
    [F.CUSTOM_FONTS]: true,
    [F.FOLDERS]: true,
    [F.DESKTOP_APP]: true,
    [F.SECURED_SHARING]: true,
    [F.AUTO_PLAY_EMBEDDED]: true,
    [F.DISABLE_LINKS]: true,
    [F.REVISION_HISTORY]: true,
    [F.CREATE_PRESENTATIONS]: 999999,
    [F.PLAYER_SETTINGS]: true,
    [F.CREATE_SLIDES]: true,
    [F.REMOVE_BAI_BRANDING]: true,
    [F.VIDEO_UPLOAD]: true,
    [F.COMMENTS]: true,
    [F.NOTIFICATIONS]: true,
    [F.REMOTE_MEETINGS]: true,
    [F.API]: true,
};

const memberFeatures = {
    ...freeFeatures,
    [F.COMMENTS]: true,
    [F.NOTIFICATIONS]: true,
    [F.TEAMS]: true,
    [F.VIEW_LIBRARY_ITEMS]: true,
};

const planFeatures = toPlanPermissions({
    // personal plans
    free: {
        name: "free",
        ...freeFeatures,
        [F.UPGRADE]: true,
    },
    pro: {
        name: "pro",
        ...proFeatures,
    },

    // team plans
    member: {
        ...memberFeatures,
        [F.UPGRADE]: true,
    },
    "member-licensed": {
        ...memberFeatures,
        ...proFeatures,
    },
    librarian: {
        ...memberFeatures,
        ...proFeatures,
        [F.EDIT_LIBRARY_ITEMS]: true,
    },
    owner: {
        ...memberFeatures,
        ...proFeatures,
        [F.EDIT_LIBRARY_ITEMS]: true,
        [F.SSO]: true,
        [F.MANAGE_TEAM]: true,
        [F.MANAGE_ORG]: true,
        [F.MANAGE_TEAM_BILLING]: true,
    }
});

// legacy plan id
planFeatures["-LfRhaqvuLMLJ0qs8aNJ"] = planFeatures["free"];

// map permissions to the format which the old planPermissions table used
function toPlanPermissions(planSpecs) {
    for (const permissionsSpec of Object.values(planSpecs)) {
        for (const [k, v] of Object.entries(permissionsSpec)) {
            if (v === true) {
                permissionsSpec[k] = { limit: undefined };
            } else if (typeof v === "number") {
                permissionsSpec[k] = { limit: v };
            } else if (v === false) {
                delete permissionsSpec[k];
            }
        }
    }
    return planSpecs;
}

function getFeatures(planNameOrTeamRole) {
    const permissions = planFeatures[planNameOrTeamRole];
    if (!permissions) {
        throw new Error("invalid plan name or team role: " + planNameOrTeamRole);
    }
    return permissions;
}

module.exports = {
    FeatureType,
    getFeatures
};
